import {
    type AiAgentId,
    CONVERSATIONAL_MM_AGENT,
    SPROUT_AGENT,
} from '@fruitful/llm-service-shared';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { XStack, YStack } from 'smoothie';

import { AiDashboardAgentNav } from './AiDashboardAgentNav';
import { AiDashboardAgentPanel } from './AiDashboardAgentPanel';

const parseSearchParam = (
    value: string | string[] | undefined,
): string | null => {
    const raw = Array.isArray(value) ? value[0] : value;
    if (raw == null || raw === '') {
        return null;
    }

    return raw;
};

const parseDashboardAgentId = (
    value: string | string[] | undefined,
): AiAgentId | null => {
    const raw = parseSearchParam(value);
    if (raw === CONVERSATIONAL_MM_AGENT.id || raw === SPROUT_AGENT.id) {
        return raw;
    }
    return null;
};

export const AiDashboardPage = () => {
    const router = useRouter();
    const { agentId: agentIdParam, resourceId: resourceIdParam } =
        useLocalSearchParams<{
            agentId?: string;
            resourceId?: string;
        }>();
    const selectedAgentId =
        parseDashboardAgentId(agentIdParam) ?? CONVERSATIONAL_MM_AGENT.id;
    const resourceId =
        selectedAgentId === SPROUT_AGENT.id
            ? parseSearchParam(resourceIdParam)
            : null;

    return (
        <XStack flex={1} gap="$4" height="100%" minHeight={0} width="100%">
            <AiDashboardAgentNav
                selectedAgentId={selectedAgentId}
                onSelectAgent={(agentId) => {
                    router.setParams({ agentId });
                }}
            />
            <YStack flex={1} minHeight={0} overflow="hidden" width="100%">
                <AiDashboardAgentPanel
                    agentId={selectedAgentId}
                    resourceId={resourceId}
                />
            </YStack>
        </XStack>
    );
};
